// extracted by mini-css-extract-plugin
export default {"skeletonWrapper":"NewsSkeleton_skeletonWrapper__fde9j","skeletonContainer":"NewsSkeleton_skeletonContainer__0aCdm","wave-lines":"NewsSkeleton_wave-lines__ObujY"};